import References from "./references";

class JsonLogicParser {

  /**
   * @param {object} conditions v1 conditions object
   */
  constructor(conditions) {
    this.data_map = {
      options: [],
      variables: [],
      conditions: []
    };

    // Getting parents tree
    this.parentsTree = References.getParentsTree();

    // Getting conditionned Options
    this.conditionnedOptions = References.getConditionnedOptions();

    // Converting conditions to json logic
    this.logic = this.convertConditions(conditions);

    return {
      logic: this.logic,
      data_map: this.data_map
    };
  }

  /**
   * Converts v1 conditions object to jsonlogic object
   * @param {object} conditions - LegalPlace's v1 model conditions
   */
  convertConditions(conditions) {
    let operator;

    // Getting first entry operator if any
    if (conditions.length > 1) {
      conditions.forEach((value, index) => {
        if (value.t && index > 0) {
          if (!operator) {
            operator = value.t;
          } else if (value.t != operator) {
            throw new Error(`Conditions object is not valid, ${operator} is not equal to ${value.t} at index ${index} in ${JSON.stringify(conditions)}`);
          }
        }
      });
    }

    // Compiling conditions
    let logic_conditions = [];
    conditions.forEach((value, index) => {
      let current_condition;
      if (typeof (value.condition_array) === 'object') {
        current_condition = this.convertConditions(value.condition_array);
      } else if (typeof (value) === 'object') {
        current_condition = this.convertSingleCondition(value);
      } else {
        throw new Error('Invalid condition');
      }
      logic_conditions.push(current_condition);
    });

    // Putting everything together
    let logic = {};
    if (operator) {
      logic[operator] = logic_conditions;
    } else if (logic_conditions.length == 1) {
      logic = logic_conditions[0];
    } else {
      throw new Error(`Invalid condition ${condition}`);
    }

    return logic;

  }

  /**
   * Convert's a single condition object to jsonlogic format
   * @param {object} condition
   */
  convertSingleCondition(condition) {
    let operation = condition.c;

    let rule = {};

    let parent_id, dataReference;

    if (condition.o !== false) {
      dataReference = {
        "var": `option.${ condition.o }`
      };
      if (this.parentsTree.options[condition.o]) {
        parent_id = this.parentsTree.options[condition.o][0];
      } else {
        parent_id = false;
      }

      // Adding option to the data map object
      this.addOptionToMap(condition.o);

      if (this.conditionnedOptions.includes(parseInt(condition.o))) {
        rule.and = [{}, {
          "selected": [{
            "var": `condition.${condition.o}`
          }]
        }];
        rule.and[0][operation] = [dataReference];
        this.addConditionToMap(condition.o);
      } else {
        rule[operation] = [dataReference];
      }

    } else if (condition.v !== false) {
      dataReference = {
        "var": `variable.${ condition.v }`
      };
      parent_id = this.parentsTree.variables[condition.v][0];

      // Adding option to the data map object
      this.addVariableToMap(condition.v);

      rule[operation] = [dataReference, condition.value];
    } else {
      throw new Error(`Invalid condition ${condition}`);
    }

    // Reading parent tree
    let parentsConditions;
    if (parent_id)
      parentsConditions = this.getParentConditions(parent_id);
    else
      parentsConditions = this.getSectionConditions(condition.o);

    let conditions = [parentsConditions, rule].filter(a => typeof (a) === "object");

    if (conditions.length === 0)
      return false;

    if (conditions.length > 1)
      return {
        "and": conditions
      };

    return rule;
  }

  /**
   * Adds option's id to the data map
   * @param {number} id
   */
  addOptionToMap(id) {
    if (!this.data_map.options.includes(id))
      this.data_map.options.push(id);
  }

  /**
   * Adds variables's id to the data map
   * @param {number} id
   */
  addVariableToMap(id) {
    if (!this.data_map.variables.includes(id))
      this.data_map.variables.push(id);
  }

  /**
   * Adds conditions's id to the data map
   * @param {number} id
   */
  addConditionToMap(id) {
    if (!this.data_map.conditions.includes(id))
      this.data_map.conditions.push(id);
  }

  /**
   * Returns and option's ascendants conditions
   * Spec: This function returns the list of all conditions required in order
   * for the option to be shown since a condition is always false when an option
   * it depends on is hidden
   * @param {number} id
   */
  getParentConditions(id) {
    let parent_id = this.parentsTree.options[id] ? this.parentsTree.options[id][0] : false;

    let condition, rule, parent;

    if (parent_id !== false && this.parentsTree.options[id].length > 0) {
      parent = this.getParentConditions(parent_id);
    } else {
      parent = this.getSectionConditions(id);
    }


    if (this.conditionnedOptions.includes(parseInt(id))) {
      condition = {
        "selected": [{
          "var": `condition.${id}`
        }]
      };
      this.addConditionToMap(id);
    }

    // If it's an option or a checkbox
    if (References.options[id] && ['radio', 'checkbox'].includes(References.options[id].meta.type)) {
      rule = {
        "selected": [{
          "var": `option.${id}`
        }]
      };
      this.addOptionToMap(id);
    }

    let conditions = [condition, rule, parent].filter(a => typeof (a) === "object");

    if (conditions.length === 0)
      return false;

    if (conditions.length > 1)
      return {
        "and": conditions
      };

    return conditions[0];

  }

  /**
   * Returns parent's section's conditions in case it has one
   * Spec: Same as getParentConditions, it's just the last line, the section's
   * condition
   * @param {number} id
   */
  getSectionConditions(option_id) {
    let section_index;

    // Looking for section
    References.sections.map((section, index) => {
      if (section.options.includes(option_id))
        section_index = index;
    });

    if (typeof (section_index) !== 'number') {
      return false
    }

    let section = References.sections[section_index];

    if (Array.isArray(section.convertConditions) && section.convertConditions.length > 0) {
      return this.convertConditions(section.convertConditions);
    } else {
      return false;
    }
  }

}

export default JsonLogicParser;


// WEBPACK FOOTER //
// ./src/logic/jsonlogic/parser.js